import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import CaptchaWidget from '../components/CaptchaWidget';
import { Link } from 'react-router-dom';
import MoonLogo from '../components/MoonLogo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [captchaSiteKey, setCaptchaSiteKey] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/auth/config`)
      .then(({ data }) => setCaptchaSiteKey(data?.captcha_site_key || null))
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (captchaSiteKey && !captchaToken) {
      setError('Please complete the captcha');
      return;
    }

    setIsSubmitting(true);
    try {
      await axios.post(`${BACKEND_URL}/api/auth/forgot-password`, {
        email,
        captcha_token: captchaToken,
      });
      // A resposta é sempre a mesma exista ou não a conta — ver o backend.
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    }
    setIsSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#06070d] via-[#0b0e1a] to-[#06070d] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center space-x-2">
            <MoonLogo size={40} />
            <span className="text-white font-semibold text-xl tracking-wide">moon<span className="text-[#f2e2a6]">.land</span></span>
          </Link>
        </div>

        <div className="bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
          <h1 className="text-2xl font-bold text-white mb-2 text-center">Reset your password</h1>
          <p className="text-gray-400 text-center mb-8">We'll email you a link to set a new one</p>

          {sent ? (
            <div className="bg-white/5 border border-white/10 rounded-lg p-4 text-gray-300 text-sm text-center" data-testid="forgot-password-sent">
              If that email is registered, we sent a reset link. Check your inbox — the link expires in 30 minutes.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 text-red-400 text-sm" data-testid="forgot-password-error">
                  {error}
                </div>
              )}

              <div>
                <label className="block text-gray-400 text-sm mb-2">Email</label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  data-testid="forgot-password-email"
                  className="bg-white/5 border-white/10 text-white placeholder:text-gray-500"
                />
              </div>

              {captchaSiteKey && (
                <CaptchaWidget
                  siteKey={captchaSiteKey}
                  onVerify={setCaptchaToken}
                  onExpire={() => setCaptchaToken(null)}
                />
              )}

              <Button
                type="submit"
                disabled={isSubmitting}
                data-testid="forgot-password-submit"
                className="w-full bg-[#f2e2a6] text-black hover:bg-[#f2e2a6]/90 font-semibold py-6"
              >
                {isSubmitting ? 'Sending...' : 'Send reset link'}
              </Button>
            </form>
          )}

          <div className="mt-6 text-center">
            <Link to="/login" className="text-[#f2e2a6] hover:underline text-sm" data-testid="goto-login">
              ← Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
